var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Icon from "./Icon";
import React from 'react';
import { space, layout } from 'styled-system';
import { css, styled } from "../utils";
var handleMouseMove = function (event) {
    var offsetY;
    var offsetX;
    var figure = event.currentTarget;
    if (event.nativeEvent.offsetX & event.nativeEvent.offsetY || event.nativeEvent.touches) {
        event.nativeEvent.offsetX
            ? (offsetX = event.nativeEvent.offsetX)
            : (offsetX = event.nativeEvent.touches[0].pageX);
        event.nativeEvent.offsetY
            ? (offsetY = event.nativeEvent.offsetY)
            : (offsetX = event.nativeEvent.touches[0].pageX);
        var x = (offsetX / figure.offsetWidth) * 100;
        var y = (offsetY / figure.offsetHeight) * 100;
        figure.style.backgroundPosition = x + '% ' + y + '%';
    }
};
var Figure = styled.figure(function (_a) {
    var imageUrl = _a.imageUrl, aspectRatio = _a.aspectRatio, zoomLevel = _a.zoomLevel;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-position: 75% 75%;\n    position: relative;\n    overflow: hidden;\n    cursor: crosshair;\n    background-repeat: no-repeat;\n    background-image: url(", ");\n    aspect-ratio: ", ";\n    background-size: ", "%;\n    .fullscreen {\n      cursor: pointer;\n      position: absolute;\n      bottom: 32px;\n      left: 32px;\n    }\n  "], ["\n    background-position: 75% 75%;\n    position: relative;\n    overflow: hidden;\n    cursor: crosshair;\n    background-repeat: no-repeat;\n    background-image: url(", ");\n    aspect-ratio: ", ";\n    background-size: ", "%;\n    .fullscreen {\n      cursor: pointer;\n      position: absolute;\n      bottom: 32px;\n      left: 32px;\n    }\n  "])), imageUrl, aspectRatio, Math.round(zoomLevel * 100));
}, space, layout);
var Image = styled.img(function () { return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    &:hover {\n      opacity: 0;\n    }\n    transition: opacity 0.5s;\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  "], ["\n    &:hover {\n      opacity: 0;\n    }\n    transition: opacity 0.5s;\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  "]))); });
var ZoomImage = function (_a) {
    var imageUrl = _a.imageUrl, alt = _a.alt, openGallery = _a.openGallery, withGalleryIcon = _a.withGalleryIcon, _b = _a.aspectRatio, aspectRatio = _b === void 0 ? 1 : _b, _c = _a.zoomLevel, zoomLevel = _c === void 0 ? 2 : _c, rest = __rest(_a, ["imageUrl", "alt", "openGallery", "withGalleryIcon", "aspectRatio", "zoomLevel"]);
    return (React.createElement(Figure, __assign({ className: "zoom", onMouseMove: handleMouseMove, imageUrl: imageUrl, zoomLevel: zoomLevel, aspectRatio: aspectRatio }, rest, { onClick: openGallery ? function () { return openGallery(); } : undefined }),
        React.createElement(Image, { src: imageUrl, alt: alt }),
        withGalleryIcon && openGallery && (React.createElement(Icon.Fullscreen, { className: "fullscreen", onClick: function () { return openGallery(); } }))));
};
export default ZoomImage;
var templateObject_1, templateObject_2;
//# sourceMappingURL=ZoomImage.js.map